// Shared helpers for fail-soft compile recovery.
// Example: parse line numbers and normalize unknown errors.
// Extract plain error-message text from unknown error payload.
export function extractErrorMessage(error: unknown): string {
  // Check whether payload is a native Error object.
  if (error instanceof Error) {
    // Return the native error message text.
    return error.message
  } else if (typeof error === 'string') {
    // Return string payloads directly.
    return error
  } else {
    // Return empty text for unsupported payloads.
    return ''
  }
}

// Parse positive line number with safe fallback to line 1.
export function toSafeLineNumber(raw: string | undefined): number {
  const parsed = Number.parseInt(raw ?? '', 10)
  // Check whether parsed text produced a valid positive line number.
  if (Number.isFinite(parsed) && parsed > 0) {
    // Return the parsed positive line number.
    return parsed
  } else {
    // Return line 1 for invalid line-number tokens.
    return 1
  }
}

// Remove one source line by 1-based line number.
export function removeSourceLine(source: string, line: number): string {
  const lines = source.split('\n')
  const targetIndex = line - 1
  // Check whether the requested line exists in the source.
  if (targetIndex < 0 || targetIndex >= lines.length) {
    // Return the original source when the line is out of range.
    return source
  } else {
    // Continue targeted line removal.
  }

  lines.splice(targetIndex, 1)
  // Return the source without the target line.
  return lines.join('\n')
}
